<template>
  <layout-auth>
    <v-toolbar flat color="grey lighten-3" height="50px">
      <v-container>
        <a
          class="sub-nav area-de-usuario"
          style="font-weight: bold; color: #222222 !important"
          @click="$router.push('/gestion-de-usuarios/perfil')"
          >{{ $t("users.userArea") }}</a
        >
        <a
          @click="$router.push('/gestion-de-usuarios/')"
          class="sub-nav gestion-de-usuarios"
        >
          {{ $t("users.userManagement") }}
        </a>
      </v-container>
    </v-toolbar>
    <v-container class="py-10">
      <v-row>
        <v-col>
          <h1 class="text-h4 font-weight-light py-5">
            {{ $t("users.userArea") }}
          </h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="4">
          <label>{{ $t("users.nameAlias") }}</label>
          <v-text-field
            dense
            outlined
            v-model="model.alias"
            hint="Maximo 50 caracteres"
            maxlength="50"
            minlength="3"
            :rules="[required, minAlias, maxAlias, minAlias]"
            :color="entityConfig.primaryColor"
            ref="aliasInput"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="4">
          <label>{{ $t("users.email") }}</label>
          <v-text-field
            dense
            outlined
            type="email"
            ref="emailInput"
            :disabled="passwordChanged"
            v-model="model.email"
            :color="entityConfig.primaryColor"
            maxlength="50"
            :rules="emailRules"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-form v-model="passwordForm">
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="4">
            <label>{{ $t("users.currentPassword") }}</label>
            <v-text-field
              dense
              outlined
              ref="currentPasswordInput"
              @change="setBackCurrentEmail()"
              :disabled="emailChanged"
              v-model="currentPassword"
              :color="entityConfig.primaryColor"
              autocomplete="false"
              :type="show1 ? 'text' : 'password'"
              :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
              maxlength="30"
              :rules="newPasswordRules"
              @click:append="show1 = !show1"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="6" lg="4">
            <label>{{ $t("users.newPassword") }}</label>
            <v-text-field
              dense
              outlined
              :disabled="emailChanged"
              @change="setBackCurrentEmail()"
              v-model="newPassword"
              :color="entityConfig.primaryColor"
              :type="show2 ? 'text' : 'password'"
              :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="show2 = !show2"
              :rules="newPasswordRules"
              autocomplete="false"
              maxlength="30"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="4">
            <label>{{ $t("users.confirmPassword") }}</label>
            <v-text-field
              dense
              outlined
              :disabled="emailChanged"
              @change="setBackCurrentEmail()"
              v-model="confirmPassword"
              :color="entityConfig.primaryColor"
              :type="show3 ? 'text' : 'password'"
              :append-icon="show3 ? 'mdi-eye-off' : 'mdi-eye'"
              @click:append="show3 = !show3"
              :rules="confirmPasswordRules"
              autocomplete="false"
              maxlength="30"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
      <v-row class="pb-5">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-btn
            depressed
            :color="entityConfig.primaryColor"
            :style="`color: ${entityConfig.secondaryColor}`"
            class="float-end v-btn-width-default"
            :disabled="!buttonActive"
            @click="saveData()"
          >
            {{ $t("supplierData.save") }}
          </v-btn>
        </v-col>
        <v-col></v-col>
      </v-row>
      <overlay :visible="spinner"></overlay>
    </v-container>
  </layout-auth>
</template>

<script>
import Api from "../../Services/index";
import LayoutAuth from "../../components/layouts/layout-auth.vue";
import Overlay from "../../components/layouts/overlay.vue";
import passwordValidator from "password-validator";

export default {
  components: { Overlay, LayoutAuth },
  data() {
    return {
      show1: false,
      show2: false,
      show3: false,
      spinner: true,
      entityConfig: {},
      currentAccount: {
        alias: "",
        email: "",
      },
      passwordForm: false,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      model: {
        alias: "",
        email: "",
      },
      required: (value) => !!value || "Este campo es requerido..",
      maxAlias: (v) => v.length <= 50 || "50 caracteres Maximo",
      minAlias: (v) => v.length >= 3 || "3 caracteres minimo",
      emailRules: [
        (v) => !!v || "Email es requerido",
        (v) => /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(v) || "Email no valido",
      ],
      newPasswordRules: [
        (v) => v?.length >= 12 || "12 caracteres Minimo",
        (v) => v?.length <= 30 || "30 caracteres Maximo",
        (v) => {
          let schema = new passwordValidator();
          schema.has().uppercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en mayuscula"
          );
        },
        (v) => {
          let schema = new passwordValidator();
          schema.has().lowercase();
          return (
            schema.validate(v) ||
            "Debe contener al menos 1 caracter en minuscula"
          );
        },
        (v) => {
          let schema = new passwordValidator();
          schema.has().digits();
          return schema.validate(v) || "Debe contener carateres numericos";
        },
        (v) => {
          let schema = new passwordValidator();
          schema.has().symbols();
          return (
            schema.validate(v) ||
            "Debe contener caracteres especiales: <>+|&!*%?:. =-"
          );
        },
        (v) =>
          !/[^\w<>+|&!*%?:. =-]/.test(v) ||
          "Caracteres especiales permitidos: <>+|&!*%?:. =-",
        (v) =>
          !/(.)\1{2}/.test(v) ||
          "No se permiten mas de 2 caracteres consecutivos",
        (v) => {
          if (this.model.alias) {
            let alias = this.model.alias?.toLowerCase().trim();
            return (
              !v?.toLowerCase().includes(alias) ||
              "El Password no debe incluir el alias"
            );
          }
          return true;
        },
      ],
      confirmPasswordRules: [
        () => this.newAndConfirmPassAreEqual || "Las contraseñas no coinciden",
      ],
    };
  },
  mounted() {
    this.entityConfig = this.$store.state.entityConfig.config;
    Api.defaults.headers.common["Authorization"] =
      "Bearer " + sessionStorage.getItem("authtoken");
    this.loadProfileData();
  },
  computed: {
    newAndConfirmPassAreEqual: function () {
      return (
        this.newPassword !== "" && this.newPassword === this.confirmPassword
      );
    },
    changedAliasOrEmail: function () {
      return (
        this.model.alias !== this.currentAccount.alias ||
        this.model.email !== this.currentAccount.email
      );
    },
    emailChanged: function () {
      return this.model.email !== this.currentAccount.email;
    },
    passwordChanged: function () {
      return (
        this.currentPassword !== "" ||
        this.newPassword !== "" ||
        this.confirmPassword !== ""
      );
    },
    currentAndNewPassAreEqual: function () {
      return this.currentPassword === this.newPassword;
    },
    buttonActive: function () {
      return (
        this.changedAliasOrEmail ||
        (this.newAndConfirmPassAreEqual && !this.currentAndNewPassAreEqual)
      );
    },
  },
  methods: {
    setBackCurrentEmail: function () {
      if (this.changedAliasOrEmail) {
        this.model.email = this.currentAccount.email;
      }
    },
    saveData() {
      this.spinner = true;
      if (this.changedAliasOrEmail) {
        this.saveAliasAndEmail();
      }
      if (this.passwordForm) {
        this.changePassword();
      }
    },
    loadProfileData() {
      this.spinner = true;
      const id = JSON.parse(sessionStorage.getItem("userData")).id;
      Api.get(`/usuarios/${id}`)
        .then((response) => {
          this.currentAccount.alias = response.data.response.alias;
          this.currentAccount.email = response.data.response.email;
          this.model = Object.assign({}, this.currentAccount);
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    saveAliasAndEmail() {
      this.spinner = true;
      const id = JSON.parse(sessionStorage.getItem("userData")).id;

      let userModel = {};
      if (this.model.alias != this.currentAccount.alias)
        userModel.alias = this.model.alias;
      if (this.model.email != this.currentAccount.email)
        userModel.email = this.model.email;

      Api.patch(`/usuarios/${id}`, userModel)
        .then(() => {
          let message = "Alias y/o Email actualizados";
          if (Object.prototype.hasOwnProperty.call(userModel, "email")) {
            message = `Datos actualizados, se enviará un correo a ${userModel.email} para completar la validación`;
          }
          this.currentAccount = Object.assign({}, this.model);
          this.$toast.success(message);
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
    changePassword() {
      this.spinner = true;
      const id = JSON.parse(sessionStorage.getItem("userData")).id;
      const passwords = {
        currentPassword: this.currentPassword,
        newPassword: this.newPassword,
      };
      Api.patch(`/usuarios/${id}/credenciales`, passwords)
        .then(() => {
          this.$toast.success("Contraseña Actualizada");
          this.passwordForm.reset();
          this.currentPassword = "";
          this.newPassword = "";
          this.confirmPassword = "";
        })
        .catch((error) => {
          this.$showError(this, error.response.data);
        })
        .finally(() => {
          this.spinner = false;
        });
    },
  },
};
</script>
